import request from '@/api/request'

function buildParams(data = {}) {
    const params = new URLSearchParams()
    Object.keys(data).forEach((key) => {
        const value = data[key]
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== '') {
                    params.append(key, item)
                }
            })
            return
        }
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, value)
        }
    })
    return params.toString()
}

export function pageNlAnalysisLocation(current,size,data) {
    let params = buildParams(data);
    return request({
        url: `/nlAnalysisLocation/page?current=${current}&size=${size}${params ? `&${params}` : ''}`,
        method: 'get'
    })
}

export function deleteNlAnalysisLocationById(id) {
    return request({
        url: '/nlAnalysisLocation?idList='+id,
        method: 'DELETE',
    })
}


export function submitNlAnalysisLocation(data) {
    return request({
        url: '/nlAnalysisLocation',
        method: 'post',
        data: data
    })
}
